// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon[data-v-0fdfc2b8]{--size:1.5rem;--background:transparent;--backgroundHover:var(--background);width:var(--size);height:var(--size);display:inline-block;background-color:var(--background);-webkit-mask-size:100%;mask-size:100%;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;transition:background-color .35s,transform .35s;cursor:pointer}.icon[data-v-0fdfc2b8]:hover{background-color:var(--backgroundHover)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
